import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {trackPageView,  trackEvent } from "../../utils/google-analytics";

import "../../styles/PagesStyles/GenAiLab.css";
import img1 from "../../assets/images/GenAI Lab/ai-model.png";
import img2 from "../../assets/images/GenAI Lab/share.png";
import img3 from "../../assets/images/GenAI Lab/ai.png";
import img4 from "../../assets/images/GenAI Lab/shield.png";
import usePageTitle from "../../hooks/usePageTitle";
import img5 from "../../assets/images/GenAI Lab/bulb.png"; 




const GenAiLab = () => {

  usePageTitle("Combat Solutions AI | GenAI Lab");

  const navigate = useNavigate();

      // ✅ GA init + page view
      useEffect(() => {
    
        trackPageView("/genai-lab");
      }, []);

  const circleItems = [
    { id: 1, img: img5, alt: "bulb", name: "Innovation" },
    { id: 2, img: img1, alt: "Model", name: "Models" },
    { id: 3, img: img2, alt: "share", name: "RAG" },
    { id: 4, img: img3, alt: "ai", name: "Agent" },
    { id: 5, img: img4, alt: "Agents", name: "Protection" },
  ];

  const capabilities = [
    {
      id: 1,
      title: "Foundation Model Selection & Hosting",
      description: "Strategic selection and secure hosting of foundation models optimized for enterprise workloads with robust infrastructure and compliance frameworks."
    },
    {
      id: 2,
      title: "Domain-Specific Fine-Tuning",
      description: "Custom model optimization using your enterprise data to achieve superior performance in specialized domains and industry-specific use cases."
    },
    {
      id: 3,
      title: "Retrieval-Augmented Generation (RAG)",
      description: "Tailored retrieval systems that enhance AI responses with your enterprise knowledge base, ensuring accurate, context-aware information delivery."
    },
    {
      id: 4,
      title: "Agentic Orchestration Platforms",
      description: "Collaborative AI agent systems that work together to solve complex enterprise challenges through intelligent coordination and task management."
    },
    {
      id: 5,
      title: "Multimodal Intelligence",
      description: "Advanced systems capable of processing and understanding multiple data types including text, images, and drawings for comprehensive intelligence."
    },
    {
      id: 6,
      title: "Evaluation & Integration",
      description: "Comprehensive testing frameworks and seamless tool integration with enterprise APIs, databases, and existing systems for complete AI deployment."
    }
  ];

  const governanceFeatures = [
    {
      id: 1,
      title: "Permission Gates",
      description: "Role-based access control for AI system actions"
    },
    {
      id: 2,
      title: "Audit Logs",
      description: "Complete traceability of AI decisions and actions"
    },
    {
      id: 3,
      title: "Explainability",
      description: "Transparent reasoning chains and decision paths"
    }
  ];

  const handleBookStrategyCall = () => {
    trackEvent("cta_click", {
      page: "GenAI Lab",
      button_text: "Contact Us",
    });

    navigate("/contact");
  };

  return (
    <div className="genai-wrapper">
      {/* Hero Banner Section */}
      <section className="hero-banner">
        <div className="top-gradient-effect"></div>
        <div className="banner-content">
          <div className="banner-badge">
            <span className="blink-text">GenAI LAB</span>
          </div>
          <h1 className="banner-title">
            Where Innovation <span>Meets</span><br />
            Production
          </h1>
          <p className="banner-description">
            The GenAI Lab powers Combat Solutions innovation, transforming data of every kind into enterprise ready AI solutions
          </p>
        </div>
      </section>

      {/* Lab Overview Section */}
      <section className="lab-overview">
        <div className="lab-container">
          {/* Circles Section */}
          <div className="circles-section">
            <div className="circles-container">
              {circleItems.map((item, index) => (
                <React.Fragment key={item.id}>
                  <div className="circle-item-wrapper">
                    <div
                      className="circle-hover-container"
                      onMouseEnter={(e) => {
                        e.currentTarget.classList.add('hovered');
                        trackEvent("circle_hover", {
                          page: "GenAI Lab",
                          item: item.name,
                        });
                      }}
                      onMouseLeave={(e) => e.currentTarget.classList.remove('hovered')}
                    >
                      <div className="circle-icon-box">
                        <div className="circle-icon">
                          <img src={item.img} alt={item.alt} />
                        </div>
                        <span className="circle-label">{item.name}</span>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>
            {/* Fixed mobile separators */}
            <div className="mobile-circle-separator-row">
              
            </div>
          </div>

          {/* Capabilities Section */}
          <div className="capabilities-section">
            <div className="capabilities-bg-effect"></div>
            <div className="section-header">
              <h2>Our Core Capabilities</h2>
               {/* Separator Line */}
      <div className="section-separator">
        <div className="separator-line"></div>
      </div>
              <p className="section-subtitle">Expert solutions tailored to your enterprise AI needs</p>
            </div>

            <div className="capabilities-grid">
              {capabilities.map((capability) => (
                <div
                  className="capability-card"
                  key={capability.id}
                  onMouseEnter={(e) => {
                    e.currentTarget.classList.add('card-hovered');
                    trackEvent("capability_interaction", {
                      page: "GenAI Lab",
                      capability: capability.title,
                    });
                  }}
                  onMouseLeave={(e) => e.currentTarget.classList.remove('card-hovered')}
                >
                 <div className="card-header">
                   <div className="card-icon">✓</div>
                  <h3>{capability.title}</h3>
                 </div>
                 <p>{capability.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

     

      {/* Governance Section */}
      <section className="governance-section">
        <div className="governance-bg-effect"></div>
        <div className="governance-container">
          <div className="section-header">
            <h2>Governance & Responsible AI</h2>
     {/* Separator Line */}
      <div className="section-separator">
        <div className="separator-line"></div>
      </div>
            <p className="section-subtitle">
              Built-in compliance, security, and transparency for regulated industries
            </p>
          </div>

          <div className="governance-features">
            {governanceFeatures.map((feature) => (
              <div
                className="governance-card"
                key={feature.id}
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add('card-hovered');
                  trackEvent("governance_interaction", {
                    page: "GenAI Lab",
                    feature: feature.title,
                  });
                }}
                onMouseLeave={(e) => e.currentTarget.classList.remove('card-hovered')}
              >

                <div className="card-icon">✓</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
       
        <div className="cta-container">
          <div className="cta-content">
            <h2>Ready to Transform Your <span>Enterprise AI?</span></h2>
            <p className="cta-description">
              Let's discuss how <strong>Combat Solutions</strong> can help you build production-ready AI systems that drive real business value.
            </p>
            <button
              className="cta-button"
              onClick={handleBookStrategyCall}
            >
              Contact Us
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-container">
         
          <div className="stats-grid">
             <div className="bottom-gradient-effect"></div>
            <div className="stat-item">
              <div className="stat-value">100%</div>
              <div className="stat-label">Enterprise Focus</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">24/7</div>
              <div className="stat-label">Global Support</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">SOC 2</div>
              <div className="stat-label">Compliant</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GenAiLab;